import { Warning as Warning_kojaro } from './Warning.kojaro';
import { Warning as Warning_phosphor } from './Warning.phosphor';
import { Warning as Warning_zoomg } from './Warning.zoomg';
import { Warning as Warning_zoomit } from './Warning.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Warning_kojaro;

    case 'zoomg':
      return Warning_zoomg;

    case 'phosphor':
      return Warning_phosphor;

    default:
      return Warning_zoomit;
  }
};

export const Warning = IconRenderer();
